import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { AtiraLinkPlanType } from '../model/plan/types/AtiraLinkPlanType.enum';
import { User } from '../model/user/User';

/** This hook is used when the app loads with plan params.
 *  this usually happens when the user clicks on a plan in atiralink.com/plans
 */
export const useShouldDirectUserToSub = (user: User) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    if (!state) {
      return;
    }

    const url = new URL(state.from);

    const searchParams = new URLSearchParams(url.search);
    const mode = searchParams.get('mode') as 'payment' | 'freeTrial' | null;
    const plan = searchParams.get('plan') as string | null;
    const from = searchParams.get('from') as 'pricing' | null;

    if (from === 'pricing' && mode && plan) {
      localStorage.setItem(
        'processCheckout',
        JSON.stringify(
          (user?.plan?.freeTrial?.hasUsed &&
            user.plan?.freeTrial?.endsAt !== null) ||
            user.plan?.type === AtiraLinkPlanType.PLAN_0,
        ),
      );
      localStorage.setItem('plan', plan);
      localStorage.setItem('mode', mode);

      navigate('/subscription');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
